import { defineElement, html, TemplateElement } from '@webtides/element-js';
import '../../../accordion-item/accordion-item.js';
import styles from '../../../../../packages/magnolia-content/magnolia-content.css';

/**
 * @property {string} title
 */
export default class AccordionItem extends TemplateElement {
    constructor() {
        super({ shadowRender: true, styles: [styles] });
    }

    properties() {
        return {
            title: '',
        };
    }

    template() {
        return html`
            <mb-accordion-item
                class="block"
                style="border-bottom: 1px solid var(--mdx-sys-color-neutral-subtle4, #CCC);"
                variant="minimal"
            >
                <h3 slot="header" class="mb-0 text-base font-medium py-24 text-green-medium">${this.title}</h3>
                <div slot="content" class="p-2">
                    <slot></slot>
                </div>
            </mb-accordion-item>
        `;
    }
}

defineElement('mb-e-banking-accordion-item', AccordionItem);
